import { render, staticRenderFns } from "./FollowBtn.vue?vue&type=template&id=1faa9e4c&"
import script from "./FollowBtn.vue?vue&type=script&lang=js&"
export * from "./FollowBtn.vue?vue&type=script&lang=js&"
import style0 from "./FollowBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports